export enum WeekStartDay {
    SUNDAY = 0,
    MONDAY = 1,
    SATURDAY = 6
}